const COUNTER_ANIMATION_LENGTH = 4000;
const COUNTER_SELECTOR = ".mol-counter .count-number";
let counterElements;

window.addEventListener("load", () => {
    const observer = new IntersectionObserver(function (entries) {
        if (entries.some(entry => entry.intersectionRatio >= 0.9 && entry.target.dataset.started === undefined)) {
            entries.forEach(el => {
                if (el.intersectionRatio >= 0.9 && el.target.dataset.started === undefined) {
                    el.target.dataset.started = true;
                }
            });
            window.requestAnimationFrame(drawFrame);
        }
    }, { threshold: 0.9 });

    counterElements = document.querySelectorAll(COUNTER_SELECTOR);
    counterElements.forEach(el => observer.observe(el));
}, false);

function drawFrame(timestamp) {
    let runAgain = false;

    for (let element of counterElements) {
        if (element.dataset.started === undefined) continue;

        let start = element.dataset.start;
        let previousTimeStamp = element.dataset.previousTimeStamp;

        if (start === undefined) {
            start = timestamp;
            element.dataset.start = timestamp;
            element.dataset.maxCount = element.innerHTML;

            runAgain = true;
        }

        let maxCount = parseInt(element.dataset.maxCount);
        const elapsed = timestamp - start;

        if (previousTimeStamp !== timestamp) {
            const absoluteProgress = Math.min(elapsed / COUNTER_ANIMATION_LENGTH, 1);
            const easedProgress = easeOutQuint(absoluteProgress);
            element.innerHTML = Math.round(maxCount * easedProgress);

            if (elapsed <= COUNTER_ANIMATION_LENGTH) {
                runAgain = true;
            }
        }

        if (elapsed < COUNTER_ANIMATION_LENGTH) {
            element.dataset.previousTimeStamp = timestamp;
        }
    }

    if (runAgain) {
        window.requestAnimationFrame(drawFrame);
    }
}

// https://easings.net
function easeOutQuint(x) {
    return x === 1 ? 1 : 1 - Math.pow(1 - x, 5);
}
